import React from 'react';
import { Icon, Input, InputOnChangeData } from 'semantic-ui-react';

type FiltroMatricoleProps = {
    onSearch: (search: string) => void
}

type FiltroMatricoleState = {
    search: string
}

export default class FiltroMatricole extends React.Component<FiltroMatricoleProps, FiltroMatricoleState> {
    constructor(props: FiltroMatricoleProps) {
        super(props);

        this.state = {
            search: ''
          };
    }

    onSearchChange = (_: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
        this.setState({ search: data.value });
    }

    onKeyPress = (event: any) => {
        if (event.key === 'Enter') {
            this.onSearch();
        }
    }

    onSearch = () => {
        const { onSearch } = this.props;
        if (onSearch) {
            // cerco sempre nella prima pagina
            onSearch(this.state.search);
        }
    }

    render() {
        return (
            <Input
                fluid
                icon={<Icon onClick={this.onSearch} name="search" inverted circular link />}
                placeholder="Ricerca matricola..."
                value={this.state.search}
                onChange={this.onSearchChange}
                onKeyPress={this.onKeyPress}
            />
        );
    }
}